import { EOnboardingDiscoverySource, ONBOARDING_DISCOVERY_SOURCES } from '@constants';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DescriptionWrapper, Wrapper } from './DiscoverySourceSelector.styles';

type DiscoverySourceSelectorProps = {
  value?: EOnboardingDiscoverySource;
  onChange?: (value: EOnboardingDiscoverySource) => void;
  allowClear?: boolean;
  disabled?: boolean;
  disableDescription?: boolean;
  placeholder?: string;
};

export const DiscoverySourceSelector: React.FC<DiscoverySourceSelectorProps> = ({
  value,
  onChange,
  allowClear = false,
  disabled = false,
  disableDescription = false,
  placeholder
}) => {
  const { t } = useTranslation('DefaultTranslations');
  const options = useMemo(
    () =>
      ONBOARDING_DISCOVERY_SOURCES.map(discoverySource => ({
        label: t(discoverySource),
        value: discoverySource
      })),
    []
  );

  return (
    <Wrapper>
      {!disableDescription && <DescriptionWrapper>{t('THIS_DATA_IS_PRIVATE')}</DescriptionWrapper>}
      <Select
        showSearch
        value={value}
        options={options}
        onChange={onChange}
        allowClear={allowClear}
        placeholder={placeholder || t('CHOOSE_AN_OPTION')}
        style={{ minWidth: '200px' }}
        disabled={disabled}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
      />
    </Wrapper>
  );
};
